import { usePageTitle } from 'utils/pageTitle';
import DashboardLayout from 'pages/_rd_dashboard/DashboardLayout';
import AlertsAndNotificationsTable from 'pages/_rd_dashboard/AlertsAndNotificationsTable';

const Alerts = () => {
	usePageTitle('Alerts');

	return (
		<DashboardLayout>
			<AlertsAndNotificationsTable title="Alerts" />
		</DashboardLayout>
	);
};

export default Alerts;
